import styled from "styled-components";

export default styled.div`
  .item-content-container {
    cursor: pointer;
    border-radius: 10px;
    transition: background-color 200ms;
    display: flex;
    align-items: center;
    overflow: hidden;

    &:hover,
    &--active {
      background-color: rgba(218, 218, 218, 0.5);
    }

    .icon-container {
      width: 60px;
      height: 60px;

      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .image-container {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 50px;
        height: 50px;
      }
    }

    .left-component,
    .right-component {
      max-width: 0px;
      opacity: 0;
      -webkit-transition: max-width 200ms ease-in-out, opacity 400ms ease-in-out;

      &--open {
        opacity: 1;
        max-width: 240px;
      }

      &--close {
        opacity: 0;
        max-width: 0px;
      }

      .left-component-cont {
        margin: 0rem 0.5rem;
      }

      .right-component-cont {
        margin: 0rem 1rem;
      }
    }
  }
`;
